export const GET_ADDRESSES_BY_POSTCODE = { type: "GET_ADDRESSES_BY_POSTCODE" }
export const GET_ADDRESSES_BY_POSTCODE_SUCCESS = {
    type: "GET_ADDRESSES_BY_POSTCODE_SUCCESS",
}
export const GET_ADDRESSES_BY_POSTCODE_FAIL = {
    type: "GET_ADDRESSES_BY_POSTCODE_FAIL",
}
